export enum RequestedStudyTypeEnum {
    None = 'None',
    Listed = 'Listed',
    Unlisted = 'Unlisted',
    External = 'External',
}
